import React from 'react';

import classNames from 'classnames';

import {useFeatureWithAnalytics} from 'components/feature';
import {Price} from 'components/price/price';
import {useGetQuoteItemsCartDataQueryKey} from 'desktopMiniCart/constants';
import {useGetQuoteItemsCartData} from 'hooks/getQuoteItemsCart/useGetQuoteItemsCart';

import s from './miniCartPricesSummary.scss';

const renderPrice = (price: number, freeText: string = 'Free') => {
    return price === 0 ? freeText : <Price>{price}</Price>;
};

const getCoupons = (coupons: string[]) => {
    if (coupons.length) {
        return <>({coupons.join(', ')})</>;
    }
    return null;
};

/**
 * Mini Cart Summary Component
 */
export const MiniCartPricesSummary = () => {
    const isDiscountColor = useFeatureWithAnalytics('dCartUI_discountColor', false, 'desktop');

    const {data} = useGetQuoteItemsCartData({
        queryKey: useGetQuoteItemsCartDataQueryKey,
    });

    const totals = data?.totals || {
        discount: {coupons: [], price: 0},
        shipping: {price: 0},
        subtotal: 0,
        totalFinalPrice: 0,
    };

    const {
        discount: {coupons, price: discountPrice},
        shipping: {price: shippingPrice},
        subtotal,
        totalFinalPrice,
    } = totals;

    return (
        <div className={s.wrapper}>
            <div className={s.priceContainer}>
                <p className={s.title}>Subtotal</p>
                <p className={s.price}>
                    <Price>{subtotal}</Price>
                </p>
            </div>

            <div className={s.priceContainer}>
                <p className={s.title}>Discount {getCoupons(coupons)}</p>
                <p
                    className={classNames(s.price, {
                        [s.discountPrice]: discountPrice !== 0,
                    })}
                >
                    {discountPrice !== 0 && <span className={s.minus}>-</span>}
                    <Price>{discountPrice}</Price>
                </p>
            </div>

            <div className={s.priceContainer}>
                <p className={s.title}>Shipping & Handling</p>
                <p className={s.price}>{renderPrice(shippingPrice)}</p>
            </div>

            <div className={s.priceContainer}>
                <p className={s.totalPriceTitle}>Grand Total:</p>
                <p className={s.totalPrice}>
                    {subtotal !== totalFinalPrice && (
                        <span className={s.prevPrice}>
                            <Price>{subtotal}</Price>
                        </span>
                    )}
                    <span
                        className={classNames(s.finalPrice, {
                            [s.finalPriceUnderDiscountFlag]: isDiscountColor,
                        })}
                    >
                        <Price>{totalFinalPrice}</Price>
                    </span>
                </p>
            </div>
        </div>
    );
};
